module.exports = __webpack_public_path__ + "img/question8.0453174d.png";